export default __webpack_public_path__ + "static/media/users.f7b47142.svg";